import React from 'react';
import './ExportButton.css';

const ExportButton = ({ onClick, disabled }) => {
  return (
    <button 
      className="export-button"
      onClick={onClick}
      disabled={disabled}
      title="Export to Excel"
    >
      <svg 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
      <span>Export to Excel</span>
    </button>
  );
};

export default ExportButton;